import Modal from '@material-ui/core/Modal';
import { useStyles } from './TTMInfoModal.styles.js';

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function TTMInfoModal(props) {
  const { t } = useTranslation();
  const classes = useStyles();

  const [fontStyle, setFontStyle] = useState('TheJamsil');

  const { open } = props;

  useEffect(() => {
    const defaultLanguage = localStorage.getItem('selectedLanguage') || navigator.language.split('-')[0];
    const defaultFont = defaultLanguage === 'ja' ? 'MPlus1' : 'TheJamsil';
    setFontStyle(defaultFont);
  }, []);

  return (
    <Modal className={fontStyle} open={!!open} onClose={() => props.onTTMInfoModalClose()}>
      <div className={classes.container}>
        <div className={classes.label}>{props.label}</div>
        <div className={classes.separater} />
        {props.tags && (
          <div className={classes.section}>
            <div className={classes.tagsTitle}>{t('historyTab.ttmInfo.tags')}:</div>
            {props.tags?.map((tag, index) => (
              <span key={index} className={classes.tag}>
                {tag}
              </span>
            ))}
          </div>
        )}
        {props.prompt && (
          <div>
            <div className={classes.sectionTitle}>{t('historyTab.ttmInfo.prompt')}:</div>
            <div className={classes.sectionText}>{props.prompt}</div>
          </div>
        )}
        {props.lyricPrompt && (
          <div>
            <div className={classes.sectionTitle}>{t('historyTab.ttmInfo.lyricPrompt')}:</div>
            <div className={classes.sectionText}>{props.lyricPrompt}</div>
          </div>
        )}
        {props.generatedLyrics && (
          <div>
            <div className={classes.lyricsContainer}>{JSON.parse(props.generatedLyrics)}</div>
          </div>
        )}
        {props.customLyrics && <div className={classes.lyricsContainer}>{JSON.parse(props.customLyrics)}</div>}
        {props.status === 'FAILED' && (
          <div className={classes.failMessage}>{t('historyTab.ttmInfo.failed')}</div>
        )}
      </div>
    </Modal>
  );
}
